/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import IndividualChatBodyNew from '../../chatComponents/IndividualChatBodyNew';
import { useEffect, useState } from 'react';
import { Sender } from '../../chatComponents/IndividualChatBodyNew';

export default function ClientFlowChat() {
    const { id: user_id } = useSelector((state: RootState) => state.user.entity);
    const { entity: activeApp } = useSelector((state: RootState) => state.application);
    const [chatGroupId, setChatGroupId] = useState('');
    const [chatUsers, setChatUsers] = useState<any[]>([]);
    const [chatUserIds, setChatUserIds] = useState<any[]>([]);
    const [messages, setMessages] = useState<any[]>([]);
    const [checked] = useState<boolean>(false);
    const [, setCanAccessBackoffice] = useState<boolean>(false);
    const [hasAccess, setHasAccess] = useState<boolean>(false);

    useEffect(() => {
        if (!user_id) return;

        if (!activeApp?.id) {
            setMessages([]);
            setChatGroupId('');
            setChatUsers([]);
            setChatUserIds([]);
            setHasAccess(false);
            return;
        }

        const isBackOffice = Boolean(
            activeApp.backoffice_name && activeApp.backoffice_id && checked
        );
        getChatMessages(activeApp.id, isBackOffice);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checked, activeApp, user_id]);

    const getChatMessages = async (applicationId: number, isBackOffice: boolean) => {
        setMessages([]);
        setChatGroupId('');
        setChatUsers([]);
        setChatUserIds([]);
        setHasAccess(false);

        try {
            const respp = await api.chatNew.get_application_chat_messages(
                applicationId.toString(),
                isBackOffice
            );
            const newChatGroupId = respp.data.chat_group_id?.toString() ?? '';
            setChatGroupId(newChatGroupId);
            setChatMessages(respp.data.messages);
            setChatUsers(respp.data.users);
            setChatUserIds(respp.data.user_ids);
            setCanAccessBackoffice(respp.data.can_access_backoffice);

            if (newChatGroupId) {
                try {
                    const accessRes = await api.chatNew.has_access(parseInt(newChatGroupId));
                    setHasAccess(Boolean(accessRes.data?.has_access));
                } catch {
                    setHasAccess(false);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const setChatMessages = (messagesData: any) => {
        const receivedMessages = messagesData.map((message: any) => {
            let sender;

            if (message.user_id === null) {
                sender = Sender.ADMIN;
            } else if (message.user_id !== user_id) {
                sender = Sender.OTHER;
            } else {
                sender = Sender.ME;
            }

            return {
                id: message.id,
                createdAt: message.created_at,
                sender: sender,
                message: message.text,
                user: message.user,
                read: message.read,
            };
        });

        setMessages((prevMessages) => {
            const messageIds = prevMessages.map((message) => message.id);
            const uniqueMessages = receivedMessages.filter(
                (message: any) => !messageIds.includes(message.id)
            );
            return [...prevMessages, ...uniqueMessages];
        });
    };

    return (
        <>
            {/* {activeApp?.backoffice_id && (
                <ChatWithBackOfficeToggle
                    name={chatUsers.join(', ')}
                    checked={checked}
                    handleChange={handleChange}
                    canAccessBackoffice={canAccessBackoffice}
                />
            )} */}
            <IndividualChatBodyNew
                checked={checked}
                chatGroupId={chatGroupId}
                chatTitle={chatUsers.join(', ')}
                messages={messages}
                setMessages={setMessages}
                chatUserIds={chatUserIds}
                hasAccess={hasAccess}
            />
        </>
    );
}
